export default __webpack_public_path__ + "static/media/next-icon.0b5fca6c.svg";